<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);
const isUpdating = ref(false);

watch(
  currentAccount,
  () => {
    const { distribute_only_to_online_agents } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!distribute_only_to_online_agents;
  },
  { deep: true, immediate: true }
);

const toggleDistributeToOffline = async () => {
  try {
    isUpdating.value = true;
    await updateAccount({
      distribute_only_to_online_agents: isEnabled.value,
    });
    useAlert(t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.API.SUCCESS'));
  } catch (error) {
    // Revert state on error
    isEnabled.value = !isEnabled.value;
    useAlert(t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.API.ERROR'));
  } finally {
    isUpdating.value = false;
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.NOTE')"
    tooltip-identifier="settings_conversation_distribution"
    with-border
  >
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
          {{ t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.LABEL') }}
        </span>
        <span class="text-xs text-slate-600 dark:text-slate-400 mt-1">
          {{ t('GENERAL_SETTINGS.FORM.DISTRIBUTE_TO_OFFLINE.HELP') }}
        </span>
      </div>
      <Switch v-model="isEnabled" @change="toggleDistributeToOffline" />
    </div>
  </SectionLayout>
</template>
